import Vue from 'vue'
import Cookies from 'js-cookie'

import { MUTATION_SET_USER_TOKEN } from '@/masteradmin/store/mutations'

import './main'

import App from './masteradmin/App.vue'
import router from './masteradmin/router'
import store from './masteradmin/store'

import masterAdminAccess from './masteradmin/mixins/masterAdminAccess'

// Set authorization token
const token = Cookies.get('h_t') || ''
store.commit(MUTATION_SET_USER_TOKEN, token)

Vue.mixin(masterAdminAccess)

/* eslint-disable no-new */
new Vue({
  ...App,
  router,
  store,
}).$mount('#app')



// WEBPACK FOOTER //
// ./client/masteradmin-entry.js